import { focusBlockEnd } from '@blocksuite/affine-shared/commands';
import { isInsideBlockByFlavour } from '@blocksuite/affine-shared/utils';
import {
  type SlashMenuConfig,
  type SlashMenuContext,
} from '@blocksuite/affine-widget-slash-menu';
import { LayoutIcon } from '@blocksuite/icons/lit';

const insertColumns = (count: number) => {
  return ({ model, std }: SlashMenuContext) => {
    const { store } = model;
    const parent = store.getParent(model);
    if (!parent) return;
    const index = parent.children.indexOf(model);
    if (index === -1) return;

    const columnsId = store.addBlock('affine:columns', {}, parent, index + 1);
    if (!columnsId) return;

    let firstParagraphId: string | undefined;
    for (let i = 0; i < count; i++) {
      const columnId = store.addBlock('affine:column', {}, columnsId);
      if (!columnId) continue;
      const paragraphId = store.addBlock('affine:paragraph', {}, columnId);
      if (i === 0) {
        firstParagraphId = paragraphId;
      }
    }

    // drop the paragraph the slash menu was typed in, if it is now empty
    if (model.text?.length === 0) {
      store.deleteBlock(model);
    }

    if (!firstParagraphId) return;
    std.host.updateComplete
      .then(() => {
        const paragraph = std.view.getBlock(firstParagraphId);
        if (!paragraph) return;
        std.command.exec(focusBlockEnd, { focusBlock: paragraph });
      })
      .catch(console.error);
  };
};

export const columnsSlashMenuConfig: SlashMenuConfig = {
  // nested column layouts are out of scope for the MVP
  disableWhen: ({ model }) =>
    isInsideBlockByFlavour(model.store, model, 'affine:column') ||
    isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
  items: [2, 3, 4].map((count, i) => ({
    name: `${count} колонки`,
    description: `Split the page into ${count} columns.`,
    icon: LayoutIcon(),
    searchAlias: [
      'columns',
      `${count} columns`,
      'колонки',
      'разделитель',
      'split',
    ],
    group: `0_Basic@${10 + i}`,
    when: ({ model }) =>
      !isInsideBlockByFlavour(model.store, model, 'affine:column') &&
      !isInsideBlockByFlavour(model.store, model, 'affine:edgeless-text'),
    action: insertColumns(count),
  })),
};
